import { LatexBlockComponent } from './latex-block';

export function effects() {
  customElements.define('hive-latex', LatexBlockComponent);
}
